import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { Auth } from "aws-amplify";
import config from "../amplifyconfig.json";
import { onError } from "@apollo/client/link/error";
import { GraphQLFormattedError } from "graphql";

type BackOfficeFormattedError = GraphQLFormattedError & {
  errorType: string;
};

const errorLink = (signOut) =>
  onError(({ graphQLErrors, networkError, response }) => {
    if (graphQLErrors)
      graphQLErrors.forEach(({ message, locations, path }) =>
        console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
      );
    if (networkError) console.error(`[Network error]: ${networkError}`);
    if (
      response.errors &&
      response.errors[0] &&
      (response.errors[0] as BackOfficeFormattedError).errorType === "Unauthorized"
    ) {
      console.log("Unauthorized, signing out");
      signOut();
    }
  });

const httpLink = createHttpLink({
  uri: config.aws_appsync_graphqlEndpoint,
});

const authLink = setContext(async (_, { headers }) => {
  const token = (await Auth.currentSession()).getAccessToken().getJwtToken();

  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
});

export const graphQlClient = (signOut) =>
  new ApolloClient({
    link: from([authLink, errorLink(signOut), httpLink]),
    cache: new InMemoryCache(),
  });
